import useLogAmplitudeEventOnce from '@eversports/amplitude-react/useLogAmplitudeEventOnce'
import Form, { useForm } from '@eversports/klimt-forms/Form'
import Stack from '@eversports/klimt-primitives/legacy/Stack'
import TextField from '@eversports/klimt-primitives/legacy/TextField'
import { useEffect, useState } from 'react'
import * as React from 'react'

import type { MatchVenue } from '../../../../../../App.types'
import FilterCheckbox, { CheckboxVariant } from '../../../../../../components/FilterCheckbox'
import { FilterFieldsetWrapper } from '../../../../../../components/FilterFieldsetWrapper'
import { Localized } from '../../../../../../localization/react'
import { AMPLITUDE_DISCOVER_SPORT_CITY_FILTER_EVENT } from '../../../../Discover.constants'
import { DiscoverFilterTypes } from '../../../../Filters/Filters.types'
import type { Action } from '../../helpers/discover-sport-matches-reducer'

interface Props {
  dispatch: React.Dispatch<Action>
  venues: Array<MatchVenue>
  variant?: CheckboxVariant
  selectedVenues?: Array<string>
}

interface InitialValues {
  venues?: Array<string>
}

const SportsFilterForm = ({ dispatch, venues, selectedVenues, variant = 'default' }: Props) => {
  const { logAmplitudeEventOnce } = useLogAmplitudeEventOnce()
  const [shownVenues, setShownVenues] = useState(venues)

  const methods = useForm<InitialValues>({ defaultValues: { venues: [] } })
  const newlySelectedVenues = methods.watch('venues')
  const { isDirty } = methods.formState

  useEffect(() => {
    methods.reset({ venues: selectedVenues ?? [] })
  }, [selectedVenues])

  useEffect(() => {
    if (!isDirty) return
    if (newlySelectedVenues?.length) {
      logAmplitudeEventOnce({
        eventName: AMPLITUDE_DISCOVER_SPORT_CITY_FILTER_EVENT,
        eventProperties: { type: DiscoverFilterTypes.venue, tab: 'match' },
      })
    }
    dispatch({ type: 'UPDATE_DISCOVER_MATCHES_VENUES_FILTER', payload: newlySelectedVenues })
  }, [newlySelectedVenues])

  const handleSearch = (value: string) => {
    setShownVenues(venues.filter((venue) => venue.name.toLowerCase().includes(value.toLowerCase())))
  }

  return (
    <Stack spacing={3}>
      <TextField
        label={<Localized id="filters-sub-sports-search-label" />}
        onChange={({ target }) => handleSearch(target.value)}
        sx={{
          '& .MuiOutlinedInput-root': {
            borderRadius: 1,
          },
          marginX: { xs: 3, lg: 0 },
        }}
      />
      <Form methods={methods}>
        <FilterFieldsetWrapper>
          {shownVenues.map((venue) => (
            <FilterCheckbox key={venue.id} value={venue.id} label={venue.name} name="venues" variant={variant} />
          ))}
        </FilterFieldsetWrapper>
      </Form>
    </Stack>
  )
}

export default SportsFilterForm
